import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Stack,
  Typography,
  // MenuItem
} from "@mui/material";
import {
  DataGrid,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarColumnsButton,
} from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../utils/api/api";
import CustomNoRowsOverlay from "../../components/NoRows";
import CreateProduction from "./_components/CreateProduction";
import moment from "moment";
import toast, { Toaster } from "react-hot-toast";
import successSound from "../../assets/audio/success.mp3";
import errorSound from "../../assets/audio/error.mp3";

function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarDensitySelector />
      <GridToolbarExport printOptions={{ disableToolbarButton: true }} />
    </GridToolbarContainer>
  );
}

const columns = [
  {
    field: "date",
    headerClassName: "header",
    headerName: "Input Date",
    width: 150,
    flex: 1,
    renderCell: ({ value }) => (
      <Typography noWrap fontSize={14}>
        {moment(value).format("DD/MM/YYYY")}
      </Typography>
    ),
  },
  {
    field: "start_date",
    headerClassName: "header",
    headerName: "Start Date",
    width: 150,
    flex: 1,
    renderCell: ({ value }) => (
      <Typography noWrap fontSize={14}>
        {value !== "" ? moment(value).format("DD/MM/YYYY") : "Not started"}
      </Typography>
    ),
  },
  {
    field: "start_time",
    headerClassName: "header",
    headerName: "Start Time",
    width: 150,
    flex: 1,
    renderCell: ({ value }) => (
      <Typography noWrap fontSize={14}>
        {value !== "" ? value : "Not started"}
      </Typography>
    ),
  },
  {
    field: "finish_date",
    headerClassName: "header",
    headerName: "Finish Date",
    width: 150,
    flex: 1,
    renderCell: ({ value }) => (
      <Typography noWrap fontSize={14}>
        {value !== "" ? moment(value).format("DD/MM/YYYY") : "Unfinished"}
      </Typography>
    ),
  },
  {
    field: "finish_time",
    headerClassName: "header",
    headerName: "Finish Time",
    width: 150,
    flex: 1,
    renderCell: ({ value }) => (
      <Typography noWrap fontSize={14}>
        {value !== "" ? value : "Unfinished"}
      </Typography>
    ),
  },
  {
    field: "code_production",
    headerClassName: "header",
    headerName: "Production Code",
    width: 150,
    flex: 1,
    renderCell: ({ value }) => (
      <Typography noWrap fontSize={14}>
        {value}
      </Typography>
    ),
  },
  {
    field: "color",
    headerClassName: "header",
    headerName: "Color",
    width: 100,
    flex: 1,
    renderCell: ({ value }) => (
      <Typography noWrap fontSize={14} textTransform={"capitalize"}>
        {value}
      </Typography>
    ),
  },
  {
    field: "customer_name",
    headerClassName: "header",
    headerName: "Customer",
    width: 100,
    flex: 1,
    renderCell: ({ value }) => (
      <Typography noWrap fontSize={14}>
        {value}
      </Typography>
    ),
  },
  {
    field: "purchase_order",
    headerClassName: "header",
    headerName: "Purchase Order",
    width: 100,
    flex: 1,
    renderCell: ({ value }) => (
      <Typography noWrap fontSize={14}>
        {value}
      </Typography>
    ),
  },
  // {
  //   field: "remark",
  //   headerClassName: "header",
  //   headerName: "Remarks",
  //   width: 200,
  //   flex: 1,
  //   renderCell: ({ value }) => (
  //     <Typography noWrap fontSize={14}>
  //       {value ? value : "-"}
  //     </Typography>
  //   ),
  // },
  {
    field: "status",
    headerClassName: "header",
    headerName: "Status",
    width: 100,
    flex: 1,
    renderCell: (params) =>
      params.value === "Planning" ? (
        <button
          style={{
            color: "#734011",
            fontFamily: "Murecho",
            fontWeight: "600",
            fontSize: "12px",
            border: "1px solid #EECEB0",
            borderRadius: "5px",
            backgroundColor: "#FFF9F2",
          }}
        >
          {params.value}
        </button>
      ) : params.value === "In Progress" ? (
        <button
          style={{
            color: "#3267E3",
            fontFamily: "Murecho",
            fontWeight: "600",
            fontSize: "12px",
            border: "1px solid #B1C5F6",
            borderRadius: "5px",
            backgroundColor: "#F0F3FF",
          }}
        >
          {params.value}
        </button>
      ) : params.value === "Done" ? (
        <button
          style={{
            color: "#21573D",
            fontFamily: "Murecho",
            fontWeight: "600",
            fontSize: "12px",
            border: "1px solid #B8DBCA",
            borderRadius: "5px",
            backgroundColor: "#F7F7F7",
          }}
        >
          {params.value}
        </button>
      ) : (
        <button
          style={{
            color: "#CB3A31",
            fontFamily: "Murecho",
            fontWeight: "600",
            fontSize: "12px",
            border: "1px solid #EEB4B0",
            borderRadius: "5px",
            backgroundColor: "#FFF4F2",
            width: "fit-content",
          }}
        >
          {params.value}
        </button>
      ),
  },

  {
    field: "_id",
    headerClassName: "header",
    headerName: "Action",
    width: 100,
    flex: 1,
    renderCell: () => (
      <button
        style={{
          color: "#fff",
          // fontFamily: "Murecho",
          fontWeight: "600",
          fontSize: "12px",
          border: "1px solid #222",
          borderRadius: "4px",
          backgroundColor: "#222",
          padding: "5px",
          cursor: "pointer",
        }}
      >
        See Details
      </button>
    ),
  },
];

const ProductionList = () => {
  const [pageSize, setPageSize] = useState(10);
  const [modalOpen, setModalOpen] = useState(false);
  const [productions, setProductions] = useState([]);
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("admin_data"));
  const token = JSON.parse(localStorage.getItem("userToken"));
  const authentication = {
    headers: { Authorization: `Bearer ${token}` },
  };
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  // const [cleanStartDate, setCleanStartDate] = useState("");
  // const [cleanEndDate, setCleanEndDate] = useState("");
  const todayDate = new Date();
  // const formatDate = moment(todayDate).format("DD/MM/YYYY");
  const limit = moment(todayDate).add(0, "days");
  const formattedLimit = moment(limit).format("YYYY-MM-DD");
  const successEffect = new Audio(successSound);
  const errorEffect = new Audio(errorSound);

  const fnEnd = (e) => {
    setEndDate(moment(e).format("DD/MM/YYYY"));
    // setCleanEndDate(moment(e).format("L"));
  };

  const fnStart = (e) => {
    setStartDate(moment(e).format("DD/MM/YYYY"));
    // setCleanStartDate(moment(e).format("L"));
  };

  const getDataByPeriod = async () => {
    await axiosInstance
      .get(
        `/api/production_lists?start_date=${startDate}&finish_date=${endDate}`,
        authentication,
      )
      .then((res) => {
        // console.log(res.data);
        if (res?.data.length === 0) {
          errorEffect.play();
          toast.error("No data found");
        } else {
          successEffect.play();
          toast.success(`${res?.data?.length} data found`);
        }
        setProductions(res.data);
      })
      .catch((error) => {
        console.log(error);
        toast.error("Oops! Something is wrong. Please try again.");
      });
  };

  const getProductions = () => {
    axiosInstance
      .get("/api/production_lists", authentication)
      .then((res) => {
        // console.log(res.data);
        setProductions(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getProductions();
  }, []);

  return (
    <Box flex="1" sx={{ backgroundColor: "#f6f6f6" }}>
      <Toaster
        position="top-center"
        reverseOrder={false}
        gutter={8}
        containerClassName=""
        containerStyle={{}}
        toastOptions={{
          className: "",
          duration: 3000,
          style: {
            background: "#FFF",
            color: "#222",
          },
          success: {
            duration: 3000,
            theme: {
              primary: "green",
              secondary: "black",
            },
          },
        }}
      />
      <CreateProduction
        open={modalOpen}
        setModalOpen={setModalOpen}
        getProductions={getProductions}
      />
      <Stack
        direction="row"
        justifyContent="space-between"
        paddingX={3}
        sx={{ backgroundColor: "#F6F6F6" }}
        paddingY={2}
      >
        <Typography variant="h4" fontWeight="500">
          Production List
        </Typography>
        {user.role === "Admin Product" && (
          <Button
            sx={{
              textTransform: "capitalize",
              borderRadius: "11px",
              backgroundColor: "#222",
              color: "#FFF",
              ":hover": {
                backgroundColor: "#444",
                color: "#FFF",
              },
            }}
            variant="contained"
            onClick={() => setModalOpen(true)}
          >
            Create Production Data
          </Button>
        )}
        {user.role === "SuperAdmin" && (
          <Button
            sx={{
              textTransform: "capitalize",
              borderRadius: "11px",
              backgroundColor: "#222",
              color: "#FFF",
              ":hover": {
                backgroundColor: "#444",
                color: "#FFF",
              },
            }}
            variant="contained"
            onClick={() => setModalOpen(true)}
          >
            Create Production Data
          </Button>
        )}
      </Stack>
      <Stack
        direction={"row"}
        justifyContent={"flex-start"}
        gap={2}
        paddingX={3}
      >
        <Stack gap={1}>
          <Typography fontSize={14}>Start date</Typography>
          <Stack sx={{ backgroundColor: "#FFF", width: "full" }}>
            <input
              name="date"
              type="date"
              onChange={(e) => fnStart(e.target.value)}
              style={{
                backgroundColor: "#FFF",
                height: "28px",
                width: "150px",
                fontFamily: "Inter",
                fontSize: "16px",
                border: "1px solid #c8c8c8",
                borderRadius: "5px",
                padding: "5px 12px",
              }}
              max={formattedLimit}
            />
          </Stack>
        </Stack>
        <Stack gap={1}>
          <Typography fontSize={14}>End date</Typography>
          <Stack sx={{ backgroundColor: "#FFFF" }}>
            <input
              name="date"
              type="date"
              onChange={(e) => fnEnd(e.target.value)}
              style={{
                backgroundColor: "#FFF",
                height: "28px",
                width: "150px",
                fontFamily: "Inter",
                fontSize: "16px",
                border: "1px solid #c8c8c8",
                borderRadius: "5px",
                padding: "5px 12px",
              }}
              max={formattedLimit}
            />
          </Stack>
        </Stack>
        <Button
          sx={{
            textTransform: "capitalize",
            borderRadius: "11px",
            backgroundColor: "#222",
            height: "40px",
            color: "#FFF",
            bottom: 0,
            marginTop: "28px",
            ":hover": {
              backgroundColor: "#444",
              color: "#FFF",
            },
          }}
          variant="contained"
          disabled={startDate === "" || endDate === "" ? true : false}
          onClick={() => getDataByPeriod()}
        >
          Get Data
        </Button>
      </Stack>

      {/* <Stack paddingX={3} gap={1}>
        <Typography fontSize={14}>Filter by month</Typography>
        <Stack sx={{ backgroundColor: "#FFFF", width: "15%" }}>
          <CustomTextField
            name="month"
            // label={"Period"}
            select
            value={month}
            onChange={(e) => setMonth(e.target.value)}
            sx={{ backgroundColor: "#FFF" }}
          >
            {months?.map((dt) => (
              <MenuItem
                key={dt._id}
                value={dt.value}
              >
                {dt.name}
              </MenuItem>
            ))}
          </CustomTextField>
        </Stack>
      </Stack> */}
      <Stack>
        <Box
          sx={{
            "& .header": {
              backgroundColor: "#FFF",
              color: "#222",
            },
            "& .header-font": {
              backgroundColor: "#F6F6F6",
              color: "#F6F6F6",
            },
            padding: 3,
          }}
        >
          <DataGrid
            rows={productions}
            columns={columns}
            pageSize={pageSize}
            autoHeight
            getRowId={(rows) => rows._id}
            header
            pagination
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[10, 15, 25]}
            components={{
              Toolbar: CustomToolbar,
              NoRowsOverlay: CustomNoRowsOverlay,
            }}
            onRowClick={(rows) =>
              navigate(`/productions/list/detail/${rows.row._id}`)
            }
            sx={{
              backgroundColor: "#fff",
              borderRadius: "10px",
              border: "none",
              color: "#535252",
            }}
          />
        </Box>
      </Stack>
    </Box>
  );
};

export default ProductionList;
